import React from 'react'
import { hasChangedValues } from 'tyan/public/utility'
import { connect } from 'react-redux'

class ItemsToBePurchasedSelect extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.GetPurchasedList('')
    }

    GetPurchasedList = (searchString = '') => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetPurchasedList',
            data: { search: searchString, id },
            onEnd: ({ errorMessage, initValues待采购明细 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ initValues待采购明细, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerConfirm = () => {
        const { id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'CreatePurchaseInfo',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        const { changedValues基本信息: { ['待采购明细-added']: added = [] } } = this.state
        return added.length > 0
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset待采购明细 = () => {
        const { initValues待采购明细 } = this.state
        return [
            {
                _checkgrid: '', name: '待采购明细', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: initValues待采购明细, onSearch: this.GetPurchasedList,
                columns: [
                    { _text: '请购单号', minWidth: 150, flex: 1 },
                    { _text: '物料代码', minWidth: 150, flex: 1 },
                    { _text: '物料名称', minWidth: 150, flex: 1 },
                    { _text: '规格型号', minWidth: 150, flex: 1 },
                    { _int: '单位', minWidth: 150, flex: 1 },
                    { _text: '数量', minWidth: 150, flex: 1 },
                    { _date: '建议采购日期', minWidth: 150, flex: 1 },
                    { _text: '用途', minWidth: 150, flex: 1 },
                    { _float: '金额', minWidth: 150, flex: 1 },
                    { _text: '申请人', minWidth: 150, flex: 1 },
                    { _date: '申请时间', minWidth: 150, flex: 1 },
                    { _text: '申请部门', minWidth: 150, flex: 1 },
                    { _text: '请购类别', minWidth: 150, flex: 1 },
                    { _text: '加急件', minWidth: 150, flex: 1 },
                    { _text: '采购类别', minWidth: 150, flex: 1 },
                    { _date: '需求送达日期', minWidth: 150, flex: 1 },
                ],
            },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, initValues待采购明细 } = this.state
        if (errorMessage) Tyan.pubForm.showError(errorMessage)
        if (!initValues待采购明细) return <Message text={'请稍等...'} />
        return <Body data={this} maxWidth="900"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}

            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset待采购明细() },
                ]
            }
        />
    }
}

export default connect()(ItemsToBePurchasedSelect)